<template>
  <div class="content-view">
    <div class="container-fluid">
      <b-card
        title="Witaj w aplikacji ZONE"
        class="mt-3"
      >
        <b-card-text>
          <p>Aby <b>złożyć</b> deklarację:</p>
          <ul>
            <li>przejdź do listy budynków,</li>
            <li>jeżeli nie dodałeś wcześniej budynku, dla którego chcesz złożyć deklarację, wybierz opcję <i>Dodaj Budynek</i> i wypełnij jego metrykę,</li>
            <li>po dodaniu budynku przejdź do listy budynków i w prawym górnym rogu karty budynku wybierz rodzaj deklaracji, którą chcesz dla niego złożyć,</li>
            <li>alternatywnie: po dodaniu budynku możesz przejść do listy deklaracji i wybrać rodzaj budynku oraz adres, dla którego chcesz złożyć deklarację.</li>
          </ul>
          <p>Aby <b>pobrać</b> złożoną deklarację:</p>
          <ul>
            <li>przejdź do zakładki <i>Pobierz swoją deklarację</i>,</li>
            <li>odszukaj deklarację, dla której chcesz wygenerować PDF.</li>
          </ul>
          <p>LUB</p>
          <ul>
            <li>przejdź do zakładki <i>Deklaracje</i>,</li>
            <li>odszukaj deklarację, dla której chcesz wygenerować plik PDF,</li>
            <li>w kolumnie <i>Akcje</i> wybierz opcję: <i>Pobierz PDF</i>.</li>
          </ul>
          <p>Aby <b>edytować</b> deklarację:</p>
          <ul>
            <li>przejdź do zakładki <i>Deklaracje</i>,</li>
            <li>odszukaj deklarację, którą chcesz edytować,</li>
            <li>w kolumnie <i>Akcje</i> wybierz opcję: <i>Edytuj</i>.</li>
          </ul>
          <p style="color: #F22">Pamiętaj! Opcja <i>Edytuj</i> dotyczy tylko i wyłącznie korygowania drobnych błędów. Każda zmiana w zakresie rodzaju źródła ciepła/spalania paliw wymaga złożenia nowej deklaracji.</p>
        </b-card-text>
        <b-button :to="{ name: 'buildings' }" variant="primary">Lista budynków</b-button>&nbsp;
        <b-button :to="{ name: 'declarations' }" variant="primary">Lista deklaracji</b-button>&nbsp;
        <b-button href="https://www.gunb.gov.pl/sites/default/files/pliki/dokumenty/instrukcja_-_ceeb_0.pdf" target="_blank" variant="primary">Instrukcja składania deklaracji</b-button>
      </b-card>
      <b-card
        title="Aktualności"
        class="mt-3"
      >
        <b-card-text>
          <p><a class="pure-link" href="https://ceeb.gov.pl/kopiowanie_tre%C5%9Bci_deklaracji_do_nowego_adresu_budynku.pdf" target="_blank">Powielenie treści deklaracji do nowego adresu budynku</a></p>
          <p><a class="pure-link" href="https://ceeb.gov.pl/nowe_wersje_formularzy_deklaracji_dot_zrodel_ciepla_i_spalania_paliw_-_panel_obywatela.pdf" target="_blank">Nowe wzory deklaracji</a></p>
        </b-card-text>
      </b-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "Welcome"
}
</script>

<style scoped>
.btn {
  margin-bottom: 0.5em;
}
a.pure-link { color: #202f64 }
</style>
